import { useAsync } from '@workday/wcp-cargo-react';
import * as React from 'react';
import { wait } from 'shared/utils/timer';
import { Canvas } from 'modules/common/Canvas';
import { ExtendPopup } from 'modules/common/components/ExtendPopup';
import { ThreeDotsLoader } from './ThreeDotsLoader';

interface ThreeDotsPopupProps<T> {
  process: () => Promise<T>;
  onSuccess?: (data?: T) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  onFailure?: (e: any) => void;
  // to avoid flashing this component briefly — a minimum duration for which it should be visible before success
  minDuration?: number;
  title?: string;
  subTitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
  firstFocusRef?: React.RefObject<any>;
}

const ThreeDotsPopup = <T,>({
  process,
  onSuccess,
  onFailure,
  minDuration = 0,
  title,
  subTitle,
  firstFocusRef,
}: ThreeDotsPopupProps<T>) => {
  useAsync(
    async () =>
      Promise.all([process(), wait(minDuration)])
        .then((data) => {
          onSuccess?.(data[0]);
        })
        .catch((e) => {
          onFailure?.(e);
        }),
    [process]
  );
  return (
    <ExtendPopup title={title} hideCloudPlatformIcon firstFocusRef={firstFocusRef}>
      <ThreeDotsLoader inline delay={0} />
      {subTitle && <Canvas.Subtext size='large'>{subTitle}</Canvas.Subtext>}
    </ExtendPopup>
  );
};

export default ThreeDotsPopup;
